"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

// [Preact X] Change AnyComponent to ComponentType
var ClientComponent = function ClientComponent(Component, name, props) {
  var Wrapper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'div';
  return (0, _preact.h)(Wrapper, {
    "data-preact": name,
    "data-props": JSON.stringify(props)
  }, (0, _preact.h)(Component, props));
};

var _default = ClientComponent;
exports.default = _default;